// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { ThemeProvider } from './src/providers/ThemeProvider';

const rootElementWithProviders = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>;
};

export default rootElementWithProviders;
